export const heroSlides = [
    {
      id: 0,
      image: '/rainy-soccer-field.jpeg',
      alt: 'Rainy soccer field',
      badgeColor: 'bg-emerald/20 border-emerald/30 text-emerald',
      badgeIcon: 'ph-fill ph-lightning',
      badgeText: 'For Players',
      headingLine1: 'CAPTURE EVERY',
      headingLine2: 'MOMENT',
      headingGradient: 'from-ember to-sunset',
      description: 'Save videos of your time playing to download and share, no subscription required.',
      btn1Class: 'bg-gradient-ember text-white',
      btn1Text: 'Purchase',
      btn1Href: 'https://akture.video/explore',
      btn2Text: 'Learn More',
      btn2Href: '/pricing',
      btn2Icon: null,
    },
    {
      id: 1,
      image: 'https://images.unsplash.com/photo-1546519638-68e109498ffc?ixlib=rb-4.0.3&auto=format&fit=crop&w=2400&q=80',
      alt: 'Basketball player dunking',
      badgeColor: 'bg-sunset/20 border-sunset/30 text-sunset',
      badgeIcon: 'ph-fill ph-basketball',
      badgeText: 'For Athletes',
      headingLine1: 'ENHANCE YOUR',
      headingLine2: 'GAME',
      headingGradient: 'from-marble to-gray-500',
      description: 'Analyze your performance with high-quality footage, revisit coaching and practice sessions, and up your expertise.',
      btn1Class: 'bg-sunset hover:bg-orange-600 text-white text-onyx',
      btn1Shadow: '0 0 20px rgba(255,111,60,0.4)',
      btn1Text: 'Purchase',
      btn1Href: 'https://akture.video/explore',
      btn2Text: 'Learn More',
      btn2Href: '/pricing',
      btn2Icon: null,
    },
    {
      id: 2,
      image: '/sports-facility.avif',
      alt: 'Sports facility',
      badgeColor: 'bg-slate/20 border-slate/30 text-slate-300',
      badgeIcon: 'ph-fill ph-house',
      badgeText: 'For Venues',
      headingLine1: 'BOOST',
      headingLine2: 'ENGAGEMENT',
      headingGradient: 'from-slate to-blue-300',
      description: 'Game footage is your facility\'s most powerful marketing tool.',
      btn1Class: 'bg-slate hover:bg-slate-700 text-white',
      btn1Text: 'Contact Us',
      btn1Href: 'https://akture.video/contact',
      btn2Text: 'Learn More',
      btn2Href: '/pricing',
      btn2Icon: null,
    },
    {
      id: 3,
      image: '/green-soccer-field.jpeg',
      alt: 'Green soccer field',
      badgeColor: 'bg-ember/20 border-ember/30 text-ember',
      badgeIcon: 'ph-fill ph-users-three',
      badgeText: 'For Family',
      headingLine1: 'NEVER MISS A',
      headingLine2: 'MOMENT',
      headingGradient: 'from-ember to-red-400',
      description: 'Never miss another match, game, or tournament - with Akture, distance doesn\'t matter and no one has to be left out.',
      btn1Class: 'bg-gradient-ember text-white',
      btn1Shadow: '0 0 15px rgba(189,32,38,0.4)',
      btn1Text: 'Purchase',
      btn1Href: 'https://akture.video/explore',
      btn2Text: 'Learn More',
      btn2Href: '/pricing',
      btn2Icon: null,
    },
    {
      id: 4,
      image: '/sand-volleyball.jpg',
      alt: 'Sand volleyball',
      badgeColor: 'bg-emerald/20 border-emerald/30 text-emerald',
      badgeIcon: 'ph-fill ph-broadcast',
      badgeText: 'New Feature',
      headingLine1: 'EVENT',
      headingLine2: 'LIVESTREAMS',
      headingGradient: 'from-marble to-gray-500',
      description: 'Site managers, owners, and coaches can start livestreams from any Akture-equipped court or field.',
      btn1Class: 'bg-gradient-ember text-white',
      btn1Text: 'Contact Us',
      btn1Href: 'https://akture.video/contact',
      btn2Text: 'Learn More',
      btn2Href: '/pricing',
      btn2Icon: null,
    },
    {
      id: 5,
      image: '/pickleball-girl.png',
      alt: 'Pickleball player',
      badgeColor: 'bg-sunset/20 border-sunset/30 text-sunset',
      badgeIcon: 'ph-fill ph-star',
      badgeText: 'Coming Soon',
      headingLine1: 'SUBSCRIPTIONS AND',
      headingLine2: 'BUNDLES',
      headingGradient: 'from-sunset to-orange-300',
      description: 'Whether you\'re posting clips daily, need a little more storage space, or just prefer the convenience of a recurring payment, we\'re building out an option for you.',
      btn1Class: 'bg-sunset hover:bg-orange-600 text-white text-onyx',
      btn1Shadow: '0 0 20px rgba(255,111,60,0.4)',
      btn1Text: 'Learn More',
      btn1Href: '/pricing',
      btn2Text: null,
      btn2Icon: null,
    },
  ];
